import moment from "moment";
import { currentLanguage } from "./storage";
export const formatDateLL = (date) => {
  return moment(date).locale(currentLanguage()).format("LL");
};
export const formatDatelll = (date) => {
  return moment(date).locale(currentLanguage()).format("lll");
};
export const localeDate = (e) => {
  return moment(e).locale(currentLanguage()).format("DD-MM-YYYY");
};
export const englishDate = (e) => {
  return moment(e).locale("en").format("YYYY-MM-DD");
};
export const englishDateTime = (e) => {
  return moment(e).locale("en").format("YYYY-MM-DDTHH:mm:ss a");
};
export const setCurrentPageandResetData = (
  setCurrentPage,
  currentPage,
  clearData
) => {
  if (clearData) clearData();
  setCurrentPage(currentPage);
};

export const objToFormData = (data) => {
  const formData = new FormData();
  for (const [key, value] of Object.entries(data)) {
    if (Array.isArray(value)) {
      value.forEach((element, index) => {
        formData.append(`${key}[${index}]`, element);
      });
    } else {
      formData.append(key, value);
    }
  }
  return formData;
};

export const filterObj = (obj) => {
  const arr = [null, "", undefined, NaN];
  for (const [key, value] of Object.entries(obj)) {
    if (arr.includes(value)) delete obj[key];
  }

  return obj;
};

export const ScrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "instant",
  });
};

export const hex2rgba = (hex, alpha = 1) => {
  const [r, g, b] = hex.match(/\w\w/g).map((x) => parseInt(x, 16));
  return `rgba(${r},${g},${b},${alpha})`;
};
